var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time-svgrepo-com_3_",
    "data-name": "time-svgrepo-com (3)",
    transform: "translate(-0.98 -0.979)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5631",
    "data-name": "Path 5631",
    d: "M12,8V19.1l8.327,8.327",
    transform: "translate(15.98 8.878)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_490",
    "data-name": "Ellipse 490",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(2.98 2.98)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.493529fc7eb0d025f68d5480f2c39f38.svg";
export { ForwardRef as ReactComponent };